import { List } from 'immutable';

const INITIAL_STATE = {
    resources: new List(),
};

export default function resourceReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    if (action.type === 'GET') {
        return { resources: new List(action.resources) };
    }
    return state;
}
